import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, RouterLink],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  private fb = inject(FormBuilder);
  private auth = inject(AuthService);
  private router = inject(Router);

  error = signal<string | null>(null);
  info = signal<string | null>(null);

  form = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
  });

  async submit() {
    this.error.set(null);
    this.info.set(null);
    if (this.form.invalid) return;
    const { email } = this.form.getRawValue();
    try {
      const res = await this.auth.forgot(email);
      this.info.set('If the email exists, a verification code has been sent.');
      await this.router.navigate(['/reset'], { queryParams: { email } });
    } catch (e: any) {
      if (e?.status === 0) {
        this.error.set('The server cannot be reached. Please check your network connection and try again.');
        return;
      }
      const code = e?.error?.error;
      if (code === 'UserNotFoundException') {
        // avoid revealing account existence
        this.info.set('If the email exists, a verification code has been sent.');
        await this.router.navigate(['/reset'], { queryParams: { email } });
        return;
      } else if (code === 'LimitExceededException' || code === 'TooManyRequestsException') {
        this.error.set('Too many attempts. Please wait and try again.');
        return;
      }
      this.error.set(e?.error?.message || 'Failed to start password reset');
    }
  }
}
